import { useEffect, useState } from "react";
import axios from "axios";

const useImportacionesSubpartida = (year, mes, token, idAdministrador) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!token || !idAdministrador) return;
      
      try {
        setLoading(true);
        const response = await axios.post(
          'https://seguimientoconductor-nodejs-pits.com/administrador_seginus/obtenerCantidadImportada',
          { anio: year, mes: mes, id_administrador: idAdministrador },
          { headers: { Authorization: token } }
        );
        
         
        setData(response.data || []);
        setError(null);
      } catch (error) {
         
        setError(error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [year, mes, token, idAdministrador]);

  return { data, loading, error };
};

export default useImportacionesSubpartida;